import styled from 'styled-components';

export const MyHubContainer = styled.main`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 5em auto;
`;

export const SectionContainer = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 3.75rem;
  gap: 1.5rem;

  > h1 {
    padding: 0 0.5rem 0.5rem;
    font: 700 1.1rem/1.1rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.themeDarker};
    border-bottom: 1px solid ${({ theme }: {theme: any}) => theme.themeSecondary};
  }
`;

interface CardsGridContainerProps {
  isMobile?: boolean;
  isReadiness?: boolean;
}

export const CardsGridContainer = styled.div<CardsGridContainerProps>`
  width: 100%;

  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  gap: ${({ isReadiness }: {isReadiness: any}) => (isReadiness ? '2rem' : '1.5rem')};
  padding: 0 1rem;

  > div {
    max-width: ${({ isReadiness }: {isReadiness: any}) => (isReadiness ? '320px' : '360px')};
    min-width: ${({ isReadiness }: {isReadiness: any}) => (isReadiness ? '300px' : '320px')};
  }

  animation-duration: 0.5s;
  animation-name: show;
  animation-fill-mode: both;

  @keyframes show {
    0% {
      transform: translateY(10px);
      opacity: 0.2;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const BannerMobile = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;

  img {
    height: 43px;
    width: 31px;
    object-fit: contain;
  }

  .text {
    h1 {
      font: 600 1rem/1.2rem 'Segoe UI', sans-serif;
    }

    h2 {
      font: 600 0.7rem/0.8rem 'Segoe UI', sans-serif;
    }
  }
`;
